module.exports = __webpack_public_path__ + "img/34.22176f5e.jpg";